class CartNotification extends HTMLElement {
  constructor() {
    super();
    console.log('🔧 CartNotification constructor called');

    this.notification = document.getElementById('cart-notification');
    console.log('🔧 Cart notification element found:', !!this.notification);
    
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    console.log('🔧 CartNotification open() called');
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        console.log('🔧 CartNotification transition ended, focusing');
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    console.log('🔧 CartNotification close() called');
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    console.log('🔧 CartNotification renderContents() called with:', parsedState);
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      console.log('🔧 Rendering section:', section.id);
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
    console.log('🔧 CartNotification sections to render:', sections);
    return sections;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    console.log('🔧 CartNotification getSectionInnerHTML called with selector:', selector);
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    console.log('🔧 CartNotification setActiveElement called with:', element);
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
